"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_DELIVERY_DATE_MODAL = void 0;
var EDIT_DELIVERY_DATE_MODAL = {
  INPUT__DELIVERY_ON: 'editDeliveryDateModal-datePicker-deliveryOn',
  BUTTON__CANCEL: 'editDeliveryDateModal-button-cancel',
  BUTTON__SAVE: 'editDeliveryDateModal-button-saveChanges',
  TEXTAREA__NOTE: 'editDeliveryDateModal-textarea-note'
};
exports.EDIT_DELIVERY_DATE_MODAL = EDIT_DELIVERY_DATE_MODAL;